import { css } from 'lit';

export const pageHeaders = css`
  h2 {
    font-size: 2em;
    font-weight: 300;
    line-height: 1.3;
    margin: 0.75em 0.5em;
    text-align: center;
  }

  h3 {
    font-size: 1em;
    font-weight: 400;
    line-height: 1.5;
    margin-bottom: 2em;
    text-align: center;
  }
`;
